import { Box } from "@bca/ui-library";
import React from "react";
import styled from "styled-components";

const StyledBadge = styled(Box)<{ isSecond: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  color: white;
  border-radius: 8px;
  margin-bottom: ${(props) => (props.isSecond ? "0px" : "2px")};
`;

interface ReportBadgeProps {
  severityCode: string;
  numberOfItems?: number;
  isSecond?: boolean;
}

const ReportBadge: React.FunctionComponent<ReportBadgeProps> = ({
  severityCode,
  numberOfItems,
  isSecond,
}) => {
  const badgePadding = numberOfItems > 9 ? "0px 3px" : "0px";

  const badgeVariant = {
    GREEN: {
      minWidth: "9px",
      height: "9px",
      background: "#00C546",
      padding: "0px",
    },
    AMBER: {
      width: "12px",
      height: "12px",
      background: "#EE9504",
      padding: badgePadding,
    },
    RED: {
      minWidth: isSecond ? "12px" : "16px",
      height: isSecond ? "12px" : "16px",
      background: "#e30613",
      padding: badgePadding,
    },
  };

  return (
    <StyledBadge
      minWidth={badgeVariant[severityCode].minWidth}
      height={badgeVariant[severityCode].height}
      width={badgeVariant[severityCode].width ?? "none"}
      backgroundColor={badgeVariant[severityCode].background}
      padding={badgeVariant[severityCode].padding}
      isSecond={isSecond}
      data-testid="status-badge"
    >
      {numberOfItems}
    </StyledBadge>
  );
};

export default ReportBadge;
